import { SortQueryDirection } from "@ds-cps/ui";

import { AzureApplicationUserModelKeys } from "../models/api-users-models";

export class CreateParamsForApiUsers extends URLSearchParams {
  withPagination(pageSize: number, pageIndex?: number) {
    this.append("pageSize", pageSize.toString());

    if (pageIndex !== undefined) {
      this.append("offset", (pageIndex * pageSize).toString());
    }
  }

  withSortBy(activeSort: AzureApplicationUserModelKeys) {
    if (activeSort) {
      this.append("sortBy", activeSort);
    }
  }

  withSortDirection(sortDirection: SortQueryDirection) {
    if (sortDirection) {
      this.append("sortDirection", `${sortDirection}`);
    }
  }
}
